let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '充电桩型号名称',
        props: 'pileTypeName',
        minWidth: 200,
    },
    {
        label: '充电桩显示名称',
        props: 'showName',
        minWidth: 200,
    },
    {
        label: '型号',
        props: 'pileTypeCode',
        minWidth: 300,
        tooltip:true,
    },
    {
        label: '规格型号',
        props: 'specificationName',
        minWidth: 200,
    },
    {
        label: '成品料号',
        props: 'materialNo',
        minWidth: 200,
    },
    {
        label: '存货大类名称',
        props: 'bigName',
        minWidth: 200,
    },
    {
        label: '类型',
        props: 'pileTypeNo',
        minWidth: 200,
    },
    {
        label: '接口类型',
        props: 'interfaceTypeName',
        minWidth: 200,
    },
    {
        label: '充电枪数量',
        props: 'gunNum',
        minWidth: 200,
    },
    {
        label: '系统状态',
        props: 'useStateName',
        minWidth: 120,
    },
    {
        label: '编辑人',
        props: 'lastModifiedByName',
        minWidth: 200,
    },
    {
        label: '编辑时间',
        props: 'lastModifiedWhen',
        minWidth: 180,
    },
];

// // 面包屑
pageConfig.listBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'title',
    name: '充电管理'
},
{
    type: 'title',
    name: '充电桩型号管理'
}];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: true,
    showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}
// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'pileTypeNo',
    editRouter: 'pileModelDetail',
};

// 路由
pageConfig.listRouter = 'pileModelList';

// 详情的面包屑
pageConfig.detailBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'title',
    name: '充电管理',
},
{
    type: 'router',
    name: '充电桩型号管理',
    router: 'pileModelList'
},
{
    type: 'title',
    name: '充电桩型号详情',
},
];

pageConfig.formRules = {
    pileTypeName: [{
        required: true,
        message: '请填写充电桩型号名称',
        trigger: 'blur'
    }],
    materialNo:[{
        required: true,
        message: '请填写成品料号',
        trigger: 'blur'
    }],
    pileTypeCode: [{
        required: true,
        message: '请填写型号',
        trigger: 'blur'
    }],
    bluetoothFlag: [
        {
            required: true,
            message: '请选择蓝牙功能',
            trigger: 'change'
        }
    ],
    warrantyTimeStatus: [
        {
            required: true,
            message: '请选择质保有效期',
            trigger: 'change'
        }
    ],
    currentOutType: [{
        required: true,
        message: '请选择电流输出类型',
        trigger: 'change'
    }],
    chargingSpeed: [{
        required: true,
        message: '请选择充电速度',
        trigger: 'change'
    }],
    interfaceType: [{
        required: true,
        message: '请选择接口类型',
        trigger: 'change'
    }],
    offHandChargingFlag: [
        {
            required: true,
            message: '请选择是否即插即充',
            trigger: 'change'
        }
    ],
    cardFlag: [
        {
            required: true,
            message: '请选择是否无感充电',
            trigger: 'change'
        }
    ],
    audioType: [
        {
            required: true,
            message: '请选择是否有音频',
            trigger: 'change'
        }
    ],
    networkStatus: [
        {
            required: true,
            message: '请选择蓝牙协议',
            trigger: 'change'
        }
    ],
    networkTimeStatus: [
        {
            required: true,
            message: '请选择联网订阅有效期',
            trigger: 'change'
        }
    ],
    phaseType: [
        {
            required: true,
            message: '请选择单项桩/三相桩',
            trigger: 'change'
        }
    ],
    ratedCurrent: [
        {
            required: true,
            message: '请填写额定电流',
            trigger: 'blur'
        }
    ],
    bigName: [
        {
            required: true,
            message: '请填写存货大类名称',
            trigger: 'blur'
        }
    ],
    bluetoothPairFlag: [
        {
            required: true,
            message: '请选择蓝牙是否配对',
            trigger: 'change'
        }
    ],
    specificationName: [
        {
            required: true,
            message: '请填写规格型号',
            trigger: 'blur'
        }
    ],
    ratedVoltage: [
        {
            required: true,
            message: '请填写额定电压',
            trigger: 'blur'
        }
    ],
    bluetoothVersion: [
        {
            required: true,
            message: '请填写蓝牙协议',
            trigger: 'blur'
        }
    ],
    gunNum: [{
        required: true,
        message: '请填写充电枪数量',
        trigger: 'blur'
    },
    {
        pattern: /^\d+(\.\d+)?$/,
        message: '请填写数字',
        trigger: 'blur'
    }
    ],
    useState: [{
        required: true,
        message: '请选择系统状态',
        trigger: 'change'
    }],
    showName: [
        {
            required: true,
            message: '请填写充电桩显示名称',
            trigger: 'blur'
        }
    ],
    businessBelong: [
        {
            required: true,
            message: '请选择业务归属',
            trigger: 'change'
        }
    ],

    ratedPower: [
        {
            required: true,
            message: '请输入额定功率',
            trigger: 'blur'
        },
        {
            required: true,
            pattern: /^(([1-9]\d*|0)(|\.\d{1,2}))$/,
            message: '请输入数字，且最多保留小数点后两位',
            trigger: 'blur'
        }
    ],

};



export default pageConfig;
